import { Card, CardContent } from '../../../components/ui/card';
import { Text } from '@folio/components/ui/text';
import { Stack } from '@folio/components/ui/flex';

export function KpiCard({ label, value, hint }: { label: string; value: string; hint: string }) {
  return (
    <Card>
      <Stack asChild gap={2}>
        <CardContent className="py-5">
          <Text size="sm" tone="muted">
            {label}
          </Text>
          <Text size="3xl" weight="semibold">
            {value}
          </Text>
          <Text size="xs" tone="muted">
            {hint}
          </Text>
        </CardContent>
      </Stack>
    </Card>
  );
}
